<template>
  <Modal class-name="vertical-center-modal" v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">修改续约意向</div>
    <Form :model="formData" :label-width="90"  :rules="formRules" ref="formData">
      <FormItem label="续约意向" prop="agreementState">
        <Select v-model="formData.agreementState" :label-in-value="true" class="item-width" placeholder="请选择续约意向">
          <Option v-for="item in renewalIntention" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input type="textarea" class="item-width" :rows="3" :autosize="true" :maxlength="150" placeholder="不超过150字" v-model="formData.remark" ></Input>
      </FormItem>
      <FormItem class="check-box" label="">
        <Checkbox  v-model="formData.isSynBoolean">是否同步到其它子合同</Checkbox>
      </FormItem>
    </Form>
    <div slot="footer">
      <div>
        <Button type="text" size="large" @click="close">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading" >
          <span v-if="!loading" >保存</span>
          <span v-else>保存中...</span>
        </Button>
      </div>  
    </div>

  </Modal>
</template>

<script type="text/ecmascript-6">
import { saveFollowAgreement,getRenewCondition } from 'api/renewalIntention'

export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    status:{
      type:Number,
      default:null
    },
    contractFid:{
      type:String,
      default:''
    }

  },
  watch:{
    n(val) {
      this.show = true
      this.projectName = ''
      this.$refs['formData'].resetFields();
    },
    status(val) {
      // 调接口
      getRenewCondition(val).then( res => {
        this.renewalIntention = res.data.renewState
      })
    }
  },
  data() {
    return {
      loading:false,
      show: false,
      renewalIntention:[],
      formData:{
        agreementState:'',
        remark:'',
        isSynBoolean:false,
        isSyn:0
      },
      formRules:{
        agreementState:[{ required: true, type:'number', message:'请选择续约意向', trigger:"change" }],
        remark:[{ required: true, message:'请输入备注', trigger: "blur" }]
      }
    }
  },
  methods:{
    close(){
      this.show = false
    },
    save() {
    // 调接口
     this.$refs[`formData`].validate(bool => {
       if(bool) {
         if(this.formData.isSynBoolean){
           this.formData.isSyn = 1
         } else {
           this.formData.isSyn = 0
         }
         let data = {
           contractFid:this.contractFid,
           remark:this.formData.remark,
           isSyn:this.formData.isSyn,
           agreementState:this.formData.agreementState
         }
         this.loading = true
         saveFollowAgreement(data).then(res => {
           this.loading = false
            this.$Message.success('操作成功！')
            this.show = false
            this.$emit('refresh')
          }).catch( err => {
            this.loading = false
          })

       }
     })
    
    }

  }
}
</script>
